import { useDirectTask } from './useDirectTask'

export function useHeaderTitle() {
  const task = useDirectTask()

  if (task?.employer_name) {
    return `Verify ${task.employer_name}`
  }

  if (task) {
    return 'Verify employer'
  }

  return 'Add employer'
}
